<template>
  <div :class="[$style['pt-com-header'],'shadow']">
      <div>
        <!-- <pt-page-breadcrumb :breadcrumbArr="currentBreadcrumbs"></pt-page-breadcrumb> -->
        </div>
    <div :class="$style['pt-com-header__content']">
      <span style="margin-right:28px">{{currentTime}}</span>
      <div :class="$style['user__content']">
        <!-- <span @click="toggle()">当前用户：{{this.$auth.user().fullName}}</span>
        <ul v-if="show" :class="$style['pt-com-header__content__logout']" @click="toggle()">
          <li @click="goEditPass">修改密码</li>
          <li @click="logout">退出登录</li>
        </ul> -->
        
        <span :class="$style.center">当前用户：{{this.$auth.user().fullName}}</span>
        <ul :class="$style['pt-com-header__content__logout']">
          <li @click="goEditPass">修改密码</li>
          <li @click="logout">退出登录</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDateObject } from '@/utils/formUtils.js'
import ptPageBreadcrumb from 'cps/base/pt-page-breadcrumb'

import { updateBreadcrumb } from '@/utils/breadcrumb'
export default {
  name: 'pt-com-header',
  data () {
    return {
      show: false,
      menuList: [],
      currentTime:''
    }
  },
  components: {
    ptPageBreadcrumb
  },
  watch: {
    '$store.state.menuList': {
      handler: function (val) {
        this.menuList = val
      },
      immediate: true
    }
  },
  computed: {
    currentRotute () {
      return this.$route
    },
    isEdit () {
      return this.$route.params && this.$route.params.isEdit && this.$route.params.isEdit === 'true'
    },
    newText () {
      return this.$route.meta && this.$route.meta.newText
    },
    isForm () {
      return this.$route.meta && this.$route.meta.isForm
    },
    isExternal () {
      return this.$route.path === '/external'
    },
    isRecollect () {
      return this.$route.query.recollect === 'true'
    },
    currentBreadcrumbs () {
      return updateBreadcrumb(this.currentRotute, this.menuList, this.isForm, this.isEdit, this.newText, this.isExternal, this.isRecollect)
    }
  },
  methods: {
    toggle () {
      this.show = !this.show
    },
    logout () {
      this.$confirm('此操作将退出当前登录用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('redirectPath')
        this.$auth.logout()
      })
    },
    goEditPass () {
      this.$router.push('/edit-password')
    }
  },
  created(){
    setInterval(()=>{
      this.currentTime = formatDateObject(new Date().getTime())
    },1000);
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import '~less/var.less';
.pt-com-header{
  position: fixed;
  top:0;
  left: 200PX;
//   width: 100%-240PX;
  width:~"calc(100% - 200px)";
  height: 60PX;
  line-height: 60PX;
  background: #fff;
  // overflow-x: hidden;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  box-shadow:10px 10px 0.1rem #eee
}
.pt-com-header__content{
  display: flex;
  justify-content:flex-end;
  align-items: center;
  padding:0 40PX;
  font-size: 14px;
}
.user__content{
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  span{
    margin-left: 15px;
  }
}
.pt-com-header__content__logout{
  position: absolute;
  left: 0;
  top:100%;
  width:100%;
  color:#409eff;
  border-top:2px solid #409eff;
  font-size: 14px;
  line-height: 40px;
  background:#fff;
  padding-left: 0px;
  box-shadow: 0px 0px 10px #eee;
  margin:0;
  text-align: center;
  display: none;
}
.user__content:hover .pt-com-header__content__logout{
  display: block
}
</style>
